import React from "react";
import styled from "styled-components";

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const Label = styled.span`
  color: rgb(33, 37, 67);
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: solid 1px
    ${(props) => (props.error ? "rgb(220, 38, 38)" : "rgb(224, 228, 244)")};
  border-radius: 8px;
  background: rgb(255, 255, 255);
  padding: 0 16px;
  height: 42px;
  transition: border-color 0.2s;

  &:focus-within {
    border-color: rgb(97, 98, 197);
  }
`;

const StyledInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  color: rgb(33, 37, 67);
  background: transparent;

  &::placeholder {
    color: rgb(179, 182, 195);
  }
`;

const Icon = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

const ErrorMessage = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  margin-top: 4px;
  text-align: start;
`;

const Required = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-weight: 700;
  margin-left: 4px;
`;

const Input = ({
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  icon,
  onIconClick,
  error,
  errorMessage,
  required = false,
  ...props
}) => {
  return (
    <InputContainer>
      {label && (
        <Label>
          {label} {required && <Required>*</Required>}
        </Label>
      )}
      <InputWrapper error={error}>
        <StyledInput
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...props}
        />
        {icon && <Icon src={icon} onClick={onIconClick} alt="input icon" />}
      </InputWrapper>
      {error && errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </InputContainer>
  );
};

export default Input;
